import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
const toNum = (v) => {
  if (v != null && typeof v === "object" && "value" in v) return Number(v.value);
  return Number(v);
};
const DevInfoPanel = ({ devInfo }) => {
  var _a;
  const isDevMode = useMemo(
    () => new URLSearchParams(window.location.search).get("isDev") === "true",
    []
  );
  const [expanded, setExpanded] = useState(false);
  if (!isDevMode) return null;
  const { devOptions, effectiveRankingWeights, brandIds, dtcRetailerIds, retailerIds, normalizedQuery, productDomain, brandHints, isFollowUp, priceConstraint, resolvedAngleStrategy } = devInfo;
  const baseWeights = devOptions.rankingWeights;
  const WeightRow = ({
    label,
    base,
    effective
  }) => {
    const b = toNum(base);
    const e = toNum(effective);
    const delta = e - b;
    const hasChange = Math.abs(delta) > 1e-3;
    return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px", fontSize: "12px" }, children: [
      /* @__PURE__ */ jsx("span", { style: { minWidth: "70px", color: "#666" }, children: label }),
      /* @__PURE__ */ jsx("span", { style: { minWidth: "38px", textAlign: "right", fontVariantNumeric: "tabular-nums", color: "#999" }, children: b.toFixed(2) }),
      /* @__PURE__ */ jsx("span", { style: { color: "#999", fontSize: "11px" }, children: "→" }),
      /* @__PURE__ */ jsx(
        "span",
        {
          style: {
            minWidth: "38px",
            textAlign: "right",
            fontVariantNumeric: "tabular-nums",
            fontWeight: 600,
            color: hasChange ? "#2563eb" : "#444"
          },
          children: e.toFixed(2)
        }
      ),
      hasChange && /* @__PURE__ */ jsxs(
        "span",
        {
          style: {
            fontSize: "11px",
            color: delta > 0 ? "#16a34a" : "#dc2626",
            fontVariantNumeric: "tabular-nums"
          },
          children: [
            "(",
            delta > 0 ? "+" : "",
            delta.toFixed(2),
            ")"
          ]
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        overflow: "hidden",
        marginBottom: "8px",
        background: "#fefce8"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            onClick: () => setExpanded((prev) => !prev),
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "6px 12px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              color: "#92400e",
              fontWeight: 500
            },
            children: [
              /* @__PURE__ */ jsx("span", { children: "Search Dev Info" }),
              /* @__PURE__ */ jsx("span", { style: { fontSize: "11px" }, children: expanded ? "▲" : "▼" })
            ]
          }
        ),
        expanded && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              padding: "10px 12px",
              fontSize: "12px",
              color: "#555",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              borderTop: "1px solid #e5e7eb",
              background: "#fffef5"
            },
            children: [
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Recall:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useTextRecall ? "#2563eb" : "#16a34a",
                        backgroundColor: devOptions.useTextRecall ? "#eff6ff" : "#f0fdf4",
                        color: devOptions.useTextRecall ? "#2563eb" : "#16a34a",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useTextRecall ? "Text" : "KNN"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Sections:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useTargetedSectionTitles ? "#2563eb" : "#6b7280",
                        backgroundColor: devOptions.useTargetedSectionTitles ? "#eff6ff" : "#f3f4f6",
                        color: devOptions.useTargetedSectionTitles ? "#2563eb" : "#6b7280",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useTargetedSectionTitles ? "Targeted" : "Legacy"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "KNN:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useTwoPhaseFiltering ? "#2563eb" : "#6b7280",
                        backgroundColor: devOptions.useTwoPhaseFiltering ? "#eff6ff" : "#f3f4f6",
                        color: devOptions.useTwoPhaseFiltering ? "#2563eb" : "#6b7280",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useTwoPhaseFiltering ? "2-Phase" : "PostFilter"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Outlier Filter:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useOutlierFiltering ? "#16a34a" : "#dc2626",
                        backgroundColor: devOptions.useOutlierFiltering ? "#f0fdf4" : "#fef2f2",
                        color: devOptions.useOutlierFiltering ? "#16a34a" : "#dc2626",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useOutlierFiltering ? "On" : "Off"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Search Angles:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.angleStrategy === "brand" ? "#2563eb" : devOptions.angleStrategy === "auto" ? "#9333ea" : "#6b7280",
                        backgroundColor: devOptions.angleStrategy === "brand" ? "#eff6ff" : devOptions.angleStrategy === "auto" ? "#faf5ff" : "#f3f4f6",
                        color: devOptions.angleStrategy === "brand" ? "#2563eb" : devOptions.angleStrategy === "auto" ? "#9333ea" : "#6b7280",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.angleStrategy === "brand" ? "Brand" : devOptions.angleStrategy === "auto" ? "Auto" : "Generic"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Rerank:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useOriginalQueryReranking ? "#16a34a" : "#dc2626",
                        backgroundColor: devOptions.useOriginalQueryReranking ? "#f0fdf4" : "#fef2f2",
                        color: devOptions.useOriginalQueryReranking ? "#16a34a" : "#dc2626",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useOriginalQueryReranking ? "On" : "Off"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Ratings:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.ignoreRatings ? "#dc2626" : "#16a34a",
                        backgroundColor: devOptions.ignoreRatings ? "#fef2f2" : "#f0fdf4",
                        color: devOptions.ignoreRatings ? "#dc2626" : "#16a34a",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.ignoreRatings ? "Ignored" : `>=${toNum(devOptions.ratingThreshold).toFixed(1)}`
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Availability:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.availabilityFilter === "apply" ? "#16a34a" : devOptions.availabilityFilter === "skipFalse" ? "#d97706" : "#dc2626",
                        backgroundColor: devOptions.availabilityFilter === "apply" ? "#f0fdf4" : devOptions.availabilityFilter === "skipFalse" ? "#fffbeb" : "#fef2f2",
                        color: devOptions.availabilityFilter === "apply" ? "#16a34a" : devOptions.availabilityFilter === "skipFalse" ? "#d97706" : "#dc2626",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.availabilityFilter === "apply" ? "Required" : devOptions.availabilityFilter === "skipFalse" ? "Skip False" : "Skip All"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "LLM:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333", fontSize: "11px" }, children: devOptions.llmModel }),
                  /* @__PURE__ */ jsx("span", { style: { color: "#999", fontSize: "11px" }, children: "/" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#666", fontSize: "11px" }, children: devOptions.llmModelLight }),
                  devOptions.recatModel ? /* @__PURE__ */ jsxs(Fragment, { children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#999", fontSize: "11px" }, children: "/" }),
                    /* @__PURE__ */ jsxs("span", { style: { fontWeight: 600, color: "#b45309", fontSize: "11px" }, children: [
                      "recat:",
                      devOptions.recatModel
                    ] })
                  ] }) : null
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Angles:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.numSearchAngles) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Categories:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.targetCategories) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Max/brand:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.maxPerBrand) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Max LLM:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.maxProductsForLLM) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Page:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.pageSize) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Per sec:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.productsPerSection) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Buffer:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.productsBuffer) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Temp:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.searchTemperature).toFixed(1) })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Semantic:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.semanticThreshold).toFixed(2) })
                ] })
              ] }),
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "4px" }, children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "2px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Ranking weights" }),
                  /* @__PURE__ */ jsx("span", { style: { fontSize: "11px", color: "#999" }, children: "(base → effective)" })
                ] }),
                /* @__PURE__ */ jsx(WeightRow, { label: "semantic", base: baseWeights.semanticWeight, effective: effectiveRankingWeights.semanticWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "sales", base: baseWeights.salesWeight, effective: effectiveRankingWeights.salesWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "content", base: baseWeights.contentWeight, effective: effectiveRankingWeights.contentWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "review", base: baseWeights.reviewWeight, effective: effectiveRankingWeights.reviewWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "reward", base: baseWeights.rewardWeight, effective: effectiveRankingWeights.rewardWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "price", base: baseWeights.priceWeight, effective: effectiveRankingWeights.priceWeight })
              ] }),
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "6px", borderTop: "1px solid #e5e7eb", paddingTop: "10px" }, children: [
                /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Search Debug" }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                  isFollowUp != null && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Follow-up:" }),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          padding: "2px 8px",
                          borderRadius: "4px",
                          border: "1px solid",
                          borderColor: isFollowUp ? "#2563eb" : "#6b7280",
                          backgroundColor: isFollowUp ? "#eff6ff" : "#f3f4f6",
                          color: isFollowUp ? "#2563eb" : "#6b7280",
                          fontSize: "11px",
                          fontWeight: 600
                        },
                        children: isFollowUp ? "Yes" : "No"
                      }
                    )
                  ] }),
                  devOptions.angleStrategy === "auto" && resolvedAngleStrategy && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "LLM chose:" }),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          padding: "2px 8px",
                          borderRadius: "4px",
                          border: "1px solid",
                          borderColor: resolvedAngleStrategy === "brand" ? "#2563eb" : "#6b7280",
                          backgroundColor: resolvedAngleStrategy === "brand" ? "#eff6ff" : "#f3f4f6",
                          color: resolvedAngleStrategy === "brand" ? "#2563eb" : "#6b7280",
                          fontSize: "11px",
                          fontWeight: 600
                        },
                        children: resolvedAngleStrategy === "brand" ? "Brand" : "Generic"
                      }
                    )
                  ] }),
                  productDomain && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Domain:" }),
                    /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333", fontSize: "11px" }, children: productDomain })
                  ] }),
                  normalizedQuery && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Normalized:" }),
                    /* @__PURE__ */ jsxs("span", { style: { fontWeight: 600, color: "#333", fontSize: "11px", fontStyle: "italic" }, children: [
                      '"',
                      normalizedQuery,
                      '"'
                    ] })
                  ] }),
                  priceConstraint && (priceConstraint.min != null || priceConstraint.max != null) && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Price:" }),
                    /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#b45309", fontSize: "11px" }, children: priceConstraint.min != null && priceConstraint.max != null ? `$${priceConstraint.min} – $${priceConstraint.max}` : priceConstraint.min != null ? `>= $${priceConstraint.min}` : `<= $${priceConstraint.max}` })
                  ] })
                ] }),
                brandHints && /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                  /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Brand Specific:" }),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          padding: "2px 8px",
                          borderRadius: "4px",
                          border: "1px solid",
                          borderColor: brandHints.isBrandSpecific ? "#2563eb" : "#6b7280",
                          backgroundColor: brandHints.isBrandSpecific ? "#eff6ff" : "#f3f4f6",
                          color: brandHints.isBrandSpecific ? "#2563eb" : "#6b7280",
                          fontSize: "11px",
                          fontWeight: 600
                        },
                        children: brandHints.isBrandSpecific ? "Yes" : "No"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Brand Wide:" }),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          padding: "2px 8px",
                          borderRadius: "4px",
                          border: "1px solid",
                          borderColor: brandHints.isBrandWide ? "#2563eb" : "#6b7280",
                          backgroundColor: brandHints.isBrandWide ? "#eff6ff" : "#f3f4f6",
                          color: brandHints.isBrandWide ? "#2563eb" : "#6b7280",
                          fontSize: "11px",
                          fontWeight: 600
                        },
                        children: brandHints.isBrandWide ? "Yes" : "No"
                      }
                    )
                  ] }),
                  ((_a = brandHints.brandNames) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Brands:" }),
                    /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333", fontSize: "11px" }, children: brandHints.brandNames.join(", ") })
                  ] })
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                  brandIds && brandIds.length > 0 && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Brand IDs:" }),
                    /* @__PURE__ */ jsxs("span", { style: { fontWeight: 600, color: "#7c3aed", fontSize: "11px", fontFamily: "monospace" }, children: [
                      "[",
                      brandIds.join(", "),
                      "]"
                    ] })
                  ] }),
                  dtcRetailerIds && dtcRetailerIds.length > 0 && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "DTC Retailer IDs:" }),
                    /* @__PURE__ */ jsxs("span", { style: { fontWeight: 600, color: "#0891b2", fontSize: "11px", fontFamily: "monospace" }, children: [
                      "[",
                      dtcRetailerIds.join(", "),
                      "]"
                    ] })
                  ] }),
                  retailerIds && retailerIds.length > 0 && /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                    /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Retailer IDs (used):" }),
                    /* @__PURE__ */ jsxs("span", { style: { fontWeight: 600, color: "#0891b2", fontSize: "11px", fontFamily: "monospace" }, children: [
                      "[",
                      retailerIds.join(", "),
                      "]"
                    ] })
                  ] }),
                  (!brandIds || brandIds.length === 0) && (!retailerIds || retailerIds.length === 0) && /* @__PURE__ */ jsx("span", { style: { fontSize: "11px", color: "#999", fontStyle: "italic" }, children: "No brand/retailer filters applied" })
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
};
export {
  DevInfoPanel as default
};
//# sourceMappingURL=DevInfoPanel.js.map
